import { render, staticRenderFns } from "./AddDependentsWrapper.vue?vue&type=template&id=59572595&scoped=true&lang=pug&"
import script from "./AddDependentsWrapper.vue?vue&type=script&lang=js&"
export * from "./AddDependentsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentsWrapper.vue?vue&type=style&index=0&id=59572595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59572595",
  null
  
)

export default component.exports